import { Card, CardContent, CardHeader, CardTitle } from "@/components/card";
import { ChartContainer, ChartLegend, ChartLegendContent, ChartTooltip, ChartTooltipContent } from "@/components/chart";
import type { JiraMetricsThroughputPoint } from "@/http/api-types";
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from "recharts";

export function ThroughputChart({ data }: { data: JiraMetricsThroughputPoint[] }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Throughput (Moved to Done)</CardTitle>
      </CardHeader>
      <CardContent>
        <ChartContainer className="h-72 w-full" config={{ done_count: { label: "Done Tickets", color: "#22c55e" } }}>
          <BarChart data={data}>
            <CartesianGrid vertical={false} />
            <XAxis dataKey="period" />
            <YAxis />
            <ChartTooltip content={<ChartTooltipContent />} />
            <ChartLegend content={<ChartLegendContent />} />
            <Bar dataKey="done_count" fill="var(--color-done_count)" />
          </BarChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
}
